import { createSlice } from '@reduxjs/toolkit';
import { findOrderUserWise } from './api';
import { initialState } from './api/interface';

const orderUserWiseSlice = createSlice({
  name: 'orderUserWise',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findOrderUserWise.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findOrderUserWise.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findOrderUserWise.rejected, (state, _) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } = orderUserWiseSlice.actions;
export default orderUserWiseSlice.reducer;
